import type { ComponentProps } from "react";

import { Banner } from "@widgets/banner";

import { EventsSlider } from "@features/events-slider/ui";
import { HomeArtSections } from "@features/home-art-sections/ui";
import { HomeGridCards } from "@features/home-grid-cards";
import { HomeHero } from "@features/home-hero/ui/home-hero";
import { HomeMoreAbout } from "@features/home-more-about/ui";
import { HowToGetSection } from "@features/how-to-get-section/ui";

import {
  type BlockWithIdAndComponent,
  DynamicZoneRenderer,
} from "@shared/ui/dynamic-zone-renderer";

import { MainAboutSection } from "@/_pages/home/ui/main-about-section";
import { MainStoriesSection } from "@/_pages/home/ui/main-stories-section/ui";
import { SliderSection } from "@/_pages/home/ui/slider-section/ui";

import type { HomePageType } from "../model";
import { mapCulturalObjectsSliderToSliderSection } from "../utils/map-cultural-objects";

import s from "./home-page.module.scss";

const blocksSchema = {
  "sections.banner": Banner,
  "sections.events-slider": EventsSlider,
  "sections.main-stories-section": MainStoriesSection,
  "sections.about-more": HomeMoreAbout,
  "sections.grid-media-list": HomeGridCards,
  // "sections.how-to-get-section": HowToGetSection,
  "sections.slider-section": SliderSection,
  "sections.art-sections": HomeArtSections,
  "sections.main-about-section": MainAboutSection,
  "sections.cultural-objects-slider": SliderSection,
};

export type HomePageProps = ComponentProps<"div"> & {
  data: HomePageType;
};

export const HomePage = (props: HomePageProps) => {
  const { data } = props;

  const blocksWithPageIcon = data?.blocks?.map((block) => {
    if (block.__component === "sections.cultural-objects-slider") {
      return {
        sliders: mapCulturalObjectsSliderToSliderSection(block),
        pageIcon: data?.pageIcon,
        __component: "sections.cultural-objects-slider",
      };
    }

    if (block.__component === "sections.main-about-section") {
      return {
        ...block,
        pageIcon: data?.pageIcon,
        // h1 главной берётся из поля "Заголовок" сингл-тайпа страницы
        pageTitle: data?.title,
      };
    }

    return {
      ...block,
      pageIcon: data?.pageIcon,
    };
  });

  return (
    <main className={s.root}>
      {data?.hero?.heroSlide?.length > 0 && (
        <HomeHero
          slides={data.hero.heroSlide}
          AITexts={data.hero.AITexts}
          pageIcon={data.pageIcon}
        />
      )}
      {blocksWithPageIcon && (
        <div className={s.blocks}>
          <DynamicZoneRenderer
            blocksData={blocksWithPageIcon as BlockWithIdAndComponent[]}
            blocksSchema={blocksSchema}
          />
          <HowToGetSection {...data.htg} />
        </div>
      )}
    </main>
  );
};

HomePage.displayName = "HomePage";
